export const FACEBOOK = 'facebook';
export const TWITTER = 'twitter';
export const LINKEDIN = 'linkedIn';
export const COPY = 'copy';
export const FACEBOOK_SOCIAL_SHARE = 'http://www.facebook.com/sharer.php?u=';
export const TWITTER_SOCIAL_SHARE = 'http://twitter.com/share?url=';
export const LINKEDIN_SOCIAL_SHARE =
  'http://www.linkedin.com/shareArticle?mini=true&url=';
